import React, { useState } from 'react';
import * as PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import TableWithJson from "../../../components/TableWithJson/TableWithJson";
import { showLoaderOrPlaceHolder, Subtitle } from "../../../components/helpers/chartHelpers";
// import { ImageButton } from './ImagePopup/ImageButton';
import { ImagePopup } from './ImagePopup/ImagePopup';

function TopBannersPerMaskTable({ bannersStore }) {
  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  const { loadingTopBannersPerMaskDateRangeCounter, topBannersPerMaskDateRange, chosenDateRangeMasks } = bannersStore;

  const columns = [
    { id: 'position', label: 'Pozycja', minWidth: 100 },
    { id: '_id', label: 'ID', minWidth: 100, format: () => `baner_${Math.floor(Math.random() * 200)}` },
    { id: 'title', label: 'Nazwa', minWidth: 100, format: () => `Baner ${Math.floor(Math.random() * 200)}` },
    { id: 'store', label: 'Sklep', minWidth: 100, format: (value) => (value && value.name.replace('four_fstore', 'sklep')) || '-' },
    // { id: 'mainImage', label: 'Obrazek', minWidth: 100, format: (value) => value && value !== '-' ? ImageButton(setImageOpen, setImageUrl, value) : '(Brak obrazka)' },
    { id: 'value', label: 'Ilość', minWidth: 100 },
  ];

  return (
    <div>
      <ImagePopup
        open={imageOpen}
        imageUrl={imageUrl}
        handleClose={() => {
          setImageOpen(false);
          setImageUrl('');
        }}
      />
      <div>
        {chosenDateRangeMasks.map((mask, index) => (
          <div key={index}>
            <Subtitle>{mask.replace('four_fstore', 'sklep').toUpperCase()}</Subtitle>
              {(topBannersPerMaskDateRange[mask] && topBannersPerMaskDateRange[mask].length === 0) ?
                showLoaderOrPlaceHolder(loadingTopBannersPerMaskDateRangeCounter !== 0, false)
                : (<TableWithJson
                  columns={columns}
                  data={topBannersPerMaskDateRange[mask] || []}
                  loadingData={loadingTopBannersPerMaskDateRangeCounter !== 0}
                  withPagination={false}
                  showJson={false}
                />)
              }
          </div>
        ))}
      </div>
    </div>
  )
}

export default inject('bannersStore')(observer(TopBannersPerMaskTable));

TopBannersPerMaskTable.propTypes = {
  bannersStore: PropTypes.shape({
    topBannersPerMaskDateRange: PropTypes.array,
    loadingTopBannersPerMaskDateRangeCounter: PropTypes.number,
    chosenDateRangeMasks: PropTypes.array
  })
};